import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchWithAuthBaseQuery } from '../api.helpers';

import { validateAndTransformResponse } from './helpers';
import { activeCasesResponseSchema, type ActiveCasesResponse } from './schemas';

import type { ActiveCase } from '#entities';
import type { DataWithValidation } from './types';

const paths = {
  activeCases: 'api/activeCases',
} as const;

export const activeCasesApi = createApi({
  reducerPath: 'activeCasesApi',
  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  endpoints: builder => ({
    getActiveCases: builder.query<DataWithValidation<ActiveCase[]>, void>({
      query: () => paths.activeCases,
      transformResponse: (response: ActiveCasesResponse) =>
        validateAndTransformResponse(
          activeCasesResponseSchema,
          response,
          value => value?.label,
          'activeCases',
        ),
    }),
  }),
});

export const { useGetActiveCasesQuery } = activeCasesApi;
